import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { LayoutDashboard, Building, Users, Database, ArrowLeft, Terminal, Shield, Activity, CreditCard, Crown, Zap, Globe, MessageSquare, Mail, Ghost, MapPin, HeartPulse } from 'lucide-react';

const navItems = [
  { to: '/dev-hub', icon: LayoutDashboard, label: 'Dashboard', end: true },
  { to: '/dev-hub/quick-access', icon: Zap, label: 'Quick Access' },
  { to: '/dev-hub/operator', icon: Crown, label: 'Operator' },
  { to: '/dev-hub/system-health', icon: HeartPulse, label: 'System Health' },
  { to: '/dev-hub/tenants', icon: Building, label: 'Tenants' },
  { to: '/dev-hub/users', icon: Users, label: 'Users' },
  { to: '/dev-hub/user-logins', icon: MapPin, label: 'User Logins' },
  { to: '/dev-hub/database', icon: Database, label: 'Database' },
  { to: '/dev-hub/orphans', icon: Ghost, label: 'Orphans' },
  { to: '/dev-hub/public-pages', icon: Globe, label: 'Public Pages' },
  { to: '/dev-hub/feedback', icon: MessageSquare, label: 'Feedback' },
  { to: '/dev-hub/email-templates', icon: Mail, label: 'Email Templates' },
  { to: '/dev-hub/audit-log', icon: Shield, label: 'Audit Log' },
  { to: '/dev-hub/billing', icon: CreditCard, label: 'Billing' },
  { to: '/dev-hub/demo-analytics', icon: Activity, label: 'Demo Analytics' },
];

export default function DevHubLayout() {
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="flex h-screen bg-slate-950" data-testid="dev-hub-layout">
      {/* Sidebar */}
      <aside className="w-56 flex-shrink-0 bg-slate-900 border-r border-slate-800 flex flex-col">
        <div className="px-4 py-5 border-b border-slate-800">
          <div className="flex items-center gap-2">
            <Terminal className="w-5 h-5 text-emerald-400" />
            <span className="font-bold text-white text-sm tracking-wide">DEV HUB</span>
          </div>
          <p className="text-[11px] text-slate-500 mt-1 truncate">{user?.email}</p>
        </div>

        <nav className="flex-1 px-3 py-4 space-y-1">
          {navItems.map(({ to, icon: Icon, label, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                `flex items-center gap-2.5 px-3 py-2 rounded-md text-sm transition-colors ${
                  isActive
                    ? 'bg-slate-800 text-emerald-400 font-medium'
                    : 'text-slate-400 hover:bg-slate-800/60 hover:text-slate-200'
                }`
              }
              data-testid={`devhub-nav-${label.toLowerCase()}`}
            >
              <Icon className="w-4 h-4" />
              {label}
            </NavLink>
          ))}
        </nav>

        <div className="px-3 py-4 border-t border-slate-800">
          <button
            onClick={() => navigate('/')}
            className="flex items-center gap-2 px-3 py-2 rounded-md text-sm text-slate-400 hover:bg-slate-800/60 hover:text-slate-200 transition-colors w-full"
            data-testid="devhub-back-to-app"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to App
          </button>
        </div>
      </aside>

      {/* Main content */}
      <main className="flex-1 overflow-auto bg-slate-950">
        <Outlet />
      </main>
    </div>
  );
}
